import React, {useState} from 'react';
import ReactMarkdown from 'react-markdown';

import {css} from 'aphrodite';

import {nodeId} from 'libs/react-widgets';
import DropdownSelector from 'components/DropdownSelector';

import './styles.scss';

const LandingPage = ({
  settings,
  styleSheet
}) => {
  // Destructure needed values from settings
  const {
    content: {
      introduction,
      initialInstruction,
      postMainContent
    } = {},
    dropdown: {
      enabled = true,
      menuItems = null,
      placeholderText = null,
      buttonLabel = 'Go',
      newTab = true
    } = {}
  } = settings;

  // Destructure styleSheet
  const {
    landingPage,
    introductionSection,
    initialInstructionSection,
    dropdown: dropdownStyle,
    dropdownSelectorDropdown,
    dropdownSelectorToggle,
    dropdownSelectorMenu,
    dropdownSelectorButton,
    postMainContent: postMainContentStyle
  } = styleSheet;

  const MarkdownSection = ({content, styleSheet = ''}) => (
    content && (
      <div className={styleSheet}>
        <ReactMarkdown escapeHtml={false}>
          {content}
        </ReactMarkdown>
      </div>
    )
  );

  return (
    <div data-component={'LandingPage'} className={css(landingPage)}>
      <MarkdownSection
        content={introduction}
        styleSheet={css(introductionSection)}
      />
      <MarkdownSection
        content={initialInstruction}
        styleSheet={css(initialInstructionSection)}
      />
      {settings.dropdown?.enabled &&
        <div className={css(dropdownStyle)}>
          <DropdownSelector id="productSelector"
            menuItems={menuItems}
            placeholderText={placeholderText}
            buttonLabel={buttonLabel}
            newTab={newTab}
            dropdownSelectorStyle={css(dropdownSelectorDropdown)}
            dropdownToggleStyle={css(dropdownSelectorToggle)}
            menuItemStyle={css(dropdownSelectorMenu)}
            gobuttonStyle={css(dropdownSelectorButton)}
          />
        </div>}
      <MarkdownSection
        content={postMainContent}
        styleSheet={css(postMainContentStyle)}
      />
    </div>
  );
};

export default LandingPage;